import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// Direction B's type scale (tailwind.config fontSize b-*) is a font size, not a colour: without this, merging
// `text-b-control` with `text-b-on-ink` drops the size.
const twMerge = extendTailwindMerge({
  extend: { classGroups: { "font-size": [{ text: ["b-title", "b-section", "b-read", "b-label", "b-control", "b-meta", "b-micro", "b-time"] }] } },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatRelativeTime(timestamp: number | Date): string {
  const now = Date.now();
  const ts = typeof timestamp === 'number' ? timestamp : timestamp.getTime();
  const diff = now - ts;

  if (diff < 60_000) return 'Just now';
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h ago`;

  const date = new Date(ts);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const time = date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

  if (date.toDateString() === yesterday.toDateString()) return `Yesterday ${time}`;

  const sixDaysAgo = new Date(today);
  sixDaysAgo.setDate(sixDaysAgo.getDate() - 6);
  if (date > sixDaysAgo) {
    return `${date.toLocaleDateString([], { weekday: 'short' })} ${time}`;
  }

  return date.toLocaleDateString([], { month: 'short', day: 'numeric' }) + ` ${time}`;
}